import mongoose from "mongoose";
import { z } from "zod";

const isValidId = (id) => mongoose.Types.ObjectId.isValid(id);

export const TestimonialSchema = z.object({
  name: z
    .string()
    .min(1, "Name is required.")
    .transform((val) => val.trim()),

  message: z
    .string()
    .min(1, "Message is required.")
    .transform((val) => val.trim()),

  rating: z
    .string()
    .transform((val) => val.trim())
    .optional()
    .refine(
      (val) => {
        if (val === "") return true; // Allow empty string (optional field)
        const num = Number(val);
        return !isNaN(num) && num >= 1 && num <= 5;
      },
      {
        message: "Rating must be a number between 1 and 5.",
      }
    ),

  order_number: z
    .string()
    .transform((val) => val.trim() || "1")
    .refine((val) => !isNaN(Number(val)) && Number.isInteger(Number(val)), {
      message: "Order number must be a valid number",
    })
    .refine((val) => Number(val) > 0, {
      message: "Order number must be greater than 0",
    }),

  profile_image: z
    .string()
    .nullable()
    .refine((value) => value === null || isValidId(value), {
      message: "Image must be a valid ObjectId or null.",
    })
    .default(null),
});
